import React, { Component } from 'react'
import { Col } from 'react-bootstrap'
import Newsletter from '../../containers/NewsletterWidget'
import News from '../PageHome/components/Noticias'
import Propiedad from '../../containers/Sections/Propiedades/propiedad'
import MoreButton from '../../components/Buttons/plus'
import ContactForm from '../commons/ContactForm/ContactForm.component'
import Imis from '../commons/SliderMarketReports/imi'
import { translate } from 'react-translate'
import Services from '../../components/Services'
import Brokers from '../../components/Brokers'
import { MainBanner } from '../commons/MainBanner/MainBanner.component'


@translate('Campos')
class Campos extends Component {

  UNSAFE_componentWillMount() {
    window.scrollTo(0, 0)
  }

  componentDidMount() {
    this.props.setPhone()
    this.props.didMount({ id: '9', name: 'Campos'})
    this.props.getList()
    this.props.loadDirectors()
    this.props.loadNewsBySector()
  }
  _onViewMore(e){
    e.preventDefault()
    this.props.loadLandings()
  }

  render () {

    const { fields, cantResults, news, imis, directors, brokers, t, services } = this.props
    const title = t('Titulo')

    return (
      <div className='container-fluid'>
        <MainBanner
          backgroundURL={'/assets/images/campos-search.jpg'}
          mainTitle={t('division_campos')}
          secondaryTitle={t('Secondary_title')}
        >
        </MainBanner>
        <Services services={services}/>
        <div className='fields-list-container'>
          <div className='text-center title-slide'>{cantResults} {t('Campos_Disponibles')}</div>
          <div className='list-box'>
            {fields.map((item, index) =>
              <Col md={4} sm={6} key={index} className='col-property'>
                <Propiedad property={item}/>
              </Col>
            )}
          </div>
          <div className='plus-btn-container'>
            <MoreButton onClickMore={(e) => this._onViewMore(e)}/>
          </div>
        </div>

        <div className='form-container'>
          <ContactForm section={title}/>
        </div>

        {/* { ((directors || []).concat(brokers || []).length > 0) ? (
          <div className='brokers-container'>
            <Brokers brokers={(directors || []).concat(brokers || [])} section={title} />
          </div>
        ) : '' } */}

        {(imis.length > 0) ?
          <div className='imis-container'>
            <Imis imis={imis}/>
          </div>: '' }
        <div className='form-newsletter-container'>
          <Newsletter />
        </div>
        {(news.length > 0) ?
          <News news={news} />
        : '' }
      </div>
    )
  }
}

export default Campos



// WEBPACK FOOTER //
// ./src/features/PageFarms/PageFarms.component.js